module.exports = __webpack_public_path__ + "static/media/5.2056b6bd.svg";